/* tslint:disable */
/* eslint-disable */
export enum ZatcaRequestStatus {
  Started = 'STARTED',
  Pending = 'PENDING',
  Error = 'ERROR',
  Completed = 'COMPLETED',
}
